<template>
  <div
    class="tw-p-[20px] md:tw-p-[40px] !tw-pb-[0px] tw-text-sm tw-font-medium"
  >
    <!-- Default score -->
    <b-row class="tw-flex tw-items-center tw-h-[54px]">
      <b-col sm="5">
        {{
          getComponentUiText(
            "app-component-assessments-override-question-default-compliance-score-1",
          )
        }}
      </b-col>
      <b-col sm="7">
        <CircularProgressPercent :percent="formModel.defaultComplianceScore" />
      </b-col>
    </b-row>
    <div @keyup-enter="onsubmit">
      <!-- Compliance Override Score -->
      <BaseInput
        v-if="props.type === AssessmentAnswerType.COMPLIANCE"
        id="complianceOverrideScore"
        v-model="formModel.complianceOverrideScore"
        :validation="vueValidate.complianceOverrideScore"
        :label="
          getComponentUiText(
            'app-component-assessments-override-question-compliance-score-1',
          )
        "
      />

      <!-- Compensating Override Score -->
      <BaseInput
        v-if="props.type === AssessmentAnswerType.COMPENSATING"
        id="compensatingOverrideScore"
        v-model="formModel.compensatingOverrideScore"
        :validation="vueValidate.compensatingOverrideScore"
        :label="
          getComponentUiText(
            'app-component-assessments-override-question-compensating-score-1',
          )
        "
      />

      <b-row class="tw-mt-[20px]">
        <b-col sm="5">
          {{
            getComponentUiText(
              "app-component-assessments-override-question-note-title-1",
            )
          }}
        </b-col>
        <b-col sm="7">
          <TextArea1
            id="note"
            v-model:value="formModel.note"
            class="tw-h-[157px]"
            :placeholder="
              getComponentUiText(
                'app-component-assessments-override-question-note-prompt-1',
              )
            "
            :no-resize="true"
            name="note"
          />
        </b-col>
      </b-row>
    </div>
  </div>

  <div class="tw-p-10 modal-assessment">
    <div class="button-container tw-flex tw-justify-end">
      <b-button
        variant="primary"
        class="button-verify tw-bg-[#387DFF] tw-py-[11px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
        type="submit"
      >
        {{
          getComponentUiText(
            "app-component-assessment-modal-assessment-save-button-1",
          )
        }}
      </b-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import CircularProgressPercent from "../common/circularProgressPercent.vue";
import {
  IAssessmentQuestionOverride,
  AssessmentAnswerType,
} from "@/interfaces/assessments/IAssessmentQuestion";
import BaseInput from "../common/form/baseInput.vue";
import { PropType, Ref, reactive, ref } from "vue";
import useVuelidate from "@vuelidate/core";
import {
  getComponentUiText,
  IsNumberBetween0And100Valid,
} from "@/utils/utilities";
import TextArea1 from "../common/textArea1.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import { IAssessmentQuestion } from "@/interfaces/assessments/IAssessmentQuestion";
import { helpers } from "@vuelidate/validators";

const overrideScoreOptions: Ref<IDropDownData[]> = ref([] as IDropDownData[]);
for (let i = 0; i <= 100; i += 5) {
  overrideScoreOptions.value.push({ id: i, name: i + "%" });
}

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  value: {
    type: Object as PropType<IAssessmentQuestion>,
    default: () => ({}),
    required: true,
  },
});

const initialForm: IAssessmentQuestionOverride = {
  defaultComplianceScore: props.value.percent,
  compensatingOverrideScore: props.value.compensatingOverrideScore
    ? props.value.compensatingOverrideScore
    : null,
  complianceOverrideScore: props.value.complianceOverrideScore
    ? props.value.complianceOverrideScore
    : null,
  compensatingType: "",
  note: "",
};

const rules = {
  defaultComplianceScore: {},
  compensatingOverrideScore: {
    IsNumberBetween0And100Valid: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-assessments-message-input-compliance-override-score-in-override-score",
        ),
      IsNumberBetween0And100Valid,
    ),
  },
  complianceOverrideScore: {
    IsNumberBetween0And100Valid: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-assessments-message-input-compliance-override-score-in-override-score",
        ),
      IsNumberBetween0And100Valid,
    ),
  },
  compensatingType: {},
  note: {},
};

const formModel = reactive({ ...initialForm });
const vueValidate = useVuelidate(rules, formModel as any);

const onsubmit = async () => {
  await vueValidate.value.$validate();
  if (vueValidate.value.$invalid) return;
};
</script>
